angular.module("dx.webapp.kayako", [
	"dx.webapp.region",
]);
